<template>
  <div>
    <div v-if="colName" class="head-box">
      <div class="c-flex c_flex_center">
        <h4>罚款问题管理</h4>
      </div>
      <!-- <div class="c-flex">
        <el-input
          placeholder="请输入关键字"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">
          新增
        </el-button>
      </div> -->
    </div>
    <div class="content-box" :class="{ 'flex-1': !colName }" style="background-color: #f2f2f2;">
      <div class="left-box" v-if="!colName">
        <!-- <c-filter></c-filter> -->
        <div class="head-box">
          <h4>字典表类型</h4>
          <div>
            <!-- 
               <i
              class="el-icon-circle-plus-outline c-pointer"
              title="添加代码类型"
            ></i>
              <i class="el-icon-edit pointer c-m-l-10" title="编辑代码类型" @click="listEdit"></i>
            <i
              class="el-icon-delete c-pointer c-m-l-10"
              title="删除代码类型"
              @click="listRemove"
            ></i> -->
          </div>
        </div>
        <div class="left-content row">
          <div class="content-group">
            <div
              v-for="(item, i) in listFpi.data"
              :key="i"
              class="content-item c-flex c-flex-between"
              :class="listForm._id == item._id ? 'is-selected' : ''"
              @click="
                listForm = item;
                getData();
              "
            >
              <span>
                {{ item.order }}） {{ item.name }}
                <el-tooltip
                  content="系统预置代码！"
                  placement="right"
                  v-if="item.createUser == '0'"
                >
                  <i class="el-icon-info" style="color:#909399"></i>
                </el-tooltip>
              </span>
              <span>{{ item.type }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content-table" style="background: #fff;">
        <div class="head-box" v-if="!colName">
          <h4 class="c-m-l-10">字典表扩展属性</h4>
          <!-- <div class="c-flex">
          </div> -->
        </div>
        <el-table
          ref="table"
          :height="colName ? 'calc(100% - 50px)' : 'calc(100% - 100px)'"
          :tree-props="{ children: 'parameterList', hasChildren: 'hasChildren' }"
          row-key="_id"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
        >
          <el-table-column fixed="right" width="240" label="操作">
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click.native="doNew(scope.row._id)"
                v-if="!colName && scope.row.parameterList"
              >
                新增
              </el-button>
              <el-button
                type="primary"
                class="c-m-l-10"
                @click="doEdit(scope.row)"
                v-if="!scope.row.parameterList || osg.has('Parameter,edit')"
              >
                编辑
              </el-button>
              <template v-if="!scope.row.parameterList || osg.has('Products,able')">
                <template v-if="scope.row.state == 0">
                  <el-button
                    @click.native.prevent="doEnable(scope.row._id)"
                    type="danger"
                    size="mini"
                  >
                    已禁用
                  </el-button>
                </template>
                <template v-else>
                  <el-button
                    @click.native.prevent="doDisable(scope.row._id)"
                    type="success"
                    size="mini"
                  >
                    已启用
                  </el-button>
                </template>
              </template>
              <el-button
                type="danger"
                class="c-m-l-10"
                @click.native.prevent="doRemove(scope.row, '删除')"
                v-if="!scope.row.parameterList || osg.has('Parameter,edit')"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="名称" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.parameterList ? scope.row.name : scope.row.keyName }}
            </template>
          </el-table-column>
          <el-table-column
            label="属性名"
            min-width="120"
            show-overflow-tooltip
            prop="key"
            v-if="!colName"
          ></el-table-column>
          <el-table-column label="值" min-width="120" show-overflow-tooltip prop="value">
            <template slot-scope="scope">
              {{ colName ? (scope.row.parameterList ? '' : scope.row.value) : scope.row.value }}
            </template>
          </el-table-column>

          <!-- <c-table :fields="extFields">
            <template slot="name">
              <el-table-column label="姓名" width="120" fixed show-overflow-tooltip prop="name">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="$router.push({ path: `/contact/${scope.row._id}` })"
                    type="text"
                  >
                    {{ scope.row.name }}
                  </el-button>
                </template>
              </el-table-column>
            </template>
            <template slot="sourceTypeCode">
              <el-table-column label="编号" width="180" prop="sourceTypeCode">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="
                      $router.push({
                        path: `/${scope.row.sourceType}/${scope.row.sourceTypeId}`
                      })
                    "
                    type="text"
                  >
                    {{ scope.row.sourceTypeCode }}
                  </el-button>
                </template>
              </el-table-column>
            </template>
          </c-table> -->
        </el-table>
        <el-pagination
          :class="'pagination' + (colName ? '' : ' c-flex c_flex_center')"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="信息"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="formData" ref="formData" label-width="120px" label-position="left">
        <el-form-item
          label="名称"
          prop="keyName"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '名称不能为空'
          }"
        >
          <el-input type="text" v-model="formData.keyName" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item
          label="属性名"
          prop="key"
          v-if="!colName"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '属性名不能为空'
          }"
        >
          <el-input type="text" v-model="formData.key" placeholder="属性名"></el-input>
        </el-form-item>
        <el-form-item
          label="值"
          prop="value"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '值不能为空'
          }"
        >
          <el-input type="number" v-model="formData.value" placeholder="值"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">
          确 定
        </el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="日志记录"
      :visible.sync="openLogDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
          <div class="activity-card-header">
            <span class="c-font-500">
              <i class="el-icon-monitor c-w-30"></i>
              {{ log.title }}
            </span>
            <span>{{ log.createTime }}</span>
          </div>
          <div class="activity-card-content">
            {{ log.content }}
          </div>
          <div class="activity-card-footer">
            <span>操作人：{{ log.createUserName }}</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <!-- <el-button
          type="primary"
          @click="changeState({ flag: -1, memo: formData.parameterStatef1Reason }, formData)"
        >
          确 定
        </el-button> -->

        <el-button @click="openLogDetail = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'Parameter',
  inject: ['viewReload'], //注入nav里的viewReload方法
  data() {
    return {
      name: 'Parameter',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: { exts: {} },
      extFields: [],
      appealExtFields: [], //申诉表单
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {},
      state: '', //已归档 archived
      refresh: true, //表格刷新
      openLogDetail: false, // 申诉日志
      log: { fpi: {} }, //日志
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      banSave: false, //禁止提交
      listFpi: {}, //左侧字典表列表
      listForm: {}, //左侧选择表单
      colName: '' //字典表类型
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  created() {
    this.colName = this.$route.query.colName;
  },
  async mounted() {
    this.getListData();
    this.doInit();
    this.osg.ajax(
      'biz/extField/query.do',
      {
        colName: 'parameter',
        _all: '1',
        'is:state|integer#and': 1,
        // 'nin:preset|array-integer#and': 1,
        sortField: 'order',
        sortOrder: 'asc'
      },
      res => {
        this.extFields = res.data;
        this.options = this.options || [];
        for (var item of res.data) {
          //解析字段配置
          if (this.$util.isJson(item.frontEndConfig)) {
            item.frontEndConfig = JSON.parse(item.frontEndConfig);
          } else {
            item.frontEndConfig = {};
          }

          if (item.valueOption) {
            this.options['codecfg_' + item.valueOption] = {
              codeId: item.valueOption
            };
          }
          //级联
          if (item.type == 'cascade')
            this.options['cascadeCode_' + item.valueOption] = {
              codeId: item.valueOption
            };
          //申诉表单的字段
          if (item.frontEndConfig.appeal) this.appealExtFields.push(item);
        }
        this.osg.codeoption(() => {
          this.osg.getFpi();
          this.getData();
        });
      },
      { noload: true }
    );
  },
  methods: {
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    // formatProvince(row, column, cellValue) {
    //   return this.osg.areaObj.province_list[cellValue];
    // },
    // formatCity(row, column, cellValue) {
    //   return this.osg.areaObj.city_list[cellValue];
    // },
    // formatDistrict(row, column, cellValue) {
    //   return this.osg.areaObj.county_list[cellValue];
    // },
    formatState(row, column, cellValue) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatLeadStatus(row, column, cellValue) {
      return this.osg.codelabel('leadStatus', cellValue);
    },
    formatLifecycleStage(row, column, cellValue) {
      return this.osg.codelabel('lifecycleStage', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
      //   this.state = this.osg.param('state');
    },
    //扩展属性
    getParameterData(callBack) {
      let sourceTypeType = (this.listForm.type = this.listForm.type || this.colName);
      if (!sourceTypeType) return;
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        'regex:keyName|string#or': this.searchValue,
        'in:sourceType|integer#and': 2, //参数来源
        'is:sourceTypeType|string#and': sourceTypeType,
        sortField: 'key',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      // $that.getParams(params);
      this.osg.ajax('parameter/query.do', params, res => {
        this.refresh = false;
        // this.fpi = res;
        this.fpi.data = this.fpi.data.map(item => {
          item.parameterList = [];
          res.data.forEach(pItem => {
            if (item._id == pItem.sourceTypeId) item.parameterList.push(pItem);
          });
          return item;
        });
        console.log(this.fpi);
        this.refresh = true;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
          if (callBack) callBack();
        });
      });
    },
    getData() {
      let type = this.listForm.type || this.colName;
      if (!type) return;
      let params = {
        type: type,
        'nin:state|integer#and': [-1],
        _all: '1'
      };
      this.osg.setFpi(params);
      this.osg.ajax('code/query.do', params, res => {
        this.fpi = res;
        this.getParameterData();
        // this.currentRow = {};
        // this.Refresh();
      });
    },
    getListData() {
      var params = {
        _all: '1',
        'nin:state|integer#and': [-1]
      };
      this.osg.ajax('codeType/query.do', params, res => {
        this.listFpi = res;
      });
    },
    doNew(sourceTypeId) {
      this.doInit();
      this.formData.sourceTypeId = sourceTypeId;
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      // this.$util.saveExtField(this.extFields, this.formData);
      if (this.osg.validate()) {
        this.$util.saveFormatExtField(this.extFields, this.formData);
        this.formData.sourceType = 2;
        this.formData.sourceTypeType = this.listForm.type = this.listForm.type || this.colName;

        this.osg.ajax('parameter/upsert.do', this.formData, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    /**
     * 日志
     */
    getLog(row) {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: row._id,
          smodule: 'parameter',
          _all: '1',
          // 'regex:content|string#or': this.log.searchValue,
          // 'gte:createTime|datetime#and': this.log.searchDate[0],
          // 'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
          this.openLogDetail = true;
        },
        { noload: true }
      );
    },
    doEnable(id) {
      this.osg.ajax('parameter/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('parameter/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(row, msg) {
      this.osg.confirm(`是否确认${msg} ${row.keyName}？`, () => {
        this.osg.ajax('parameter/remove/' + row._id + '.do', null, () => {
          this.getData();
          this.osg.toast(`已${msg} ${row.keyName}`);
        });
      });
    }
  },
  watch: {
    $route() {
      // window.$this = this;
      // this.colName = this.$route.query.colName;
      //将过滤条件都删除
      this.viewReload();
    }
  }
};
</script>
<style>
.c-upload-maxLimit .el-icon-delete {
  display: none;
}
.c-upload-maxLimit .el-icon-close-tip {
  display: none !important;
}
</style>
